import { AlertLineReportDTO } from "src/models/alert-line-report/alert-line-report-dto";
import { STOModel } from "src/models/base/sto-model";
import { BaseApiService } from "../base";

export class UpdateAlertLineReportStatusApiService extends BaseApiService<AlertLineReportDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/AlertLine",
      loadItemsPath: "/UpdateAlertLineReportStatus",
    });
  }
}
